import { LINKS_APOIO_E_PATROCINEO, LINKS_INICIO, LINKS_PARA_CLIENTES, LINKS_PARA_MERCADOS, LINKS_WEB_APP } from '../../../Links';
import { utils_site_ref_launch_app } from '../../utils/utils_site_ref';

export const ExternalNavLinks = () => {
    const links = [
        {
            label: "📲 App versão web",
            path: LINKS_WEB_APP,
            showWidth: 768,
            _onclick: () => { utils_site_ref_launch_app() }
        },
        {
            label: "Início",
            path: LINKS_INICIO,
        },
        {
            label: "Para Clientes",
            path: LINKS_PARA_CLIENTES,
        },
        {
            label: "Para Mercados",
            path: LINKS_PARA_MERCADOS,
        },
        {
            label: "Apoio e Patrocínio",
            path: LINKS_APOIO_E_PATROCINEO,
        }
    ];
    //para colocar o id para identificar na nav o link
    for (let i = 0; i < links.length; i++)
        links[i].id = i + 1
    return links;
}